export default "__VITE_ASSET__Dk4xkY1a__"